import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_nav_scroll_bottom_expand';

const readInitialValue = (): boolean => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		// Default on: Android needs an explicit near-bottom expand (no rubber-band).
		if (stored === null) return true;
		return stored === 'true';
	} catch {
		return true;
	}
};

/**
 * When true, the floating pill restores from compact when the scroller is near
 * the bottom (needed on Android WebViews that do not fire overscroll deltas).
 * When false, expand only on upward scroll / compact dismiss.
 */
export const navScrollBottomExpandEnabled = writable<boolean>(readInitialValue());

navScrollBottomExpandEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isNavScrollBottomExpandEnabled = (): boolean => get(navScrollBottomExpandEnabled);

export const setNavScrollBottomExpandEnabled = (enabled: boolean) => {
	navScrollBottomExpandEnabled.set(enabled);
};
